import styled from 'styled-components'

const GuildVaultStyled = styled.div`
  width: 100%;
  .guild-vault {
    .line__guild--gradiant {
      height: 2px;
      padding: 30px 0;
      img {
        width: 100%;
        height: 2px;
      }
    }
    .tab-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .tabs-button {
      display: flex;
      gap: 12px;
      align-items: flex-end;
      .btn-enabled {
        filter: brightness(0.5);
      }
    }
    .d-flex {
      display: flex;
      align-items: baseline;
      gap: 24px;
    }

    .tab-content {
      color: white;
    }

    .donate-action {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`

export const ButtonSyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 30px;
`

export default GuildVaultStyled
